<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Trip Voucher</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="!loading && !voucher" class="empty">
    <ion-icon name="hourglass-outline" size="large"></ion-icon>
    <p>{{ notFoundMsg ?? 'Voucher will be available once a driver accepts.' }}</p>
  </div>

  <ion-card *ngIf="voucher" class="voucher-card">
    <ion-card-header>
      <ion-card-subtitle>Confirmed</ion-card-subtitle>
      <ion-card-title>{{ voucher.nomePassageiro }}</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <div class="row"><strong>From:</strong> {{ voucher.enderecoOrigem }}</div>
      <div class="row"><strong>To:</strong> {{ voucher.enderecoDestino }}</div>
      <div class="row" *ngIf="voucher.dataAgendamentoCorrida"><strong>When:</strong> {{ voucher.dataAgendamentoCorrida | date:'MMM d, y, h:mm a' }}</div>
      <div class="row" *ngIf="voucher.nomeMotorista"><strong>Driver:</strong> {{ voucher.nomeMotorista }}</div>
      <div class="row" *ngIf="voucher.celularMotorista"><strong>Driver phone:</strong> {{ voucher.celularMotorista }}</div>
      <div class="row" *ngIf="voucher.veiculoTipo"><strong>Vehicle:</strong> {{ voucher.veiculoTipo }}</div>
      <div class="row" *ngIf="voucher.celularPassageiro"><strong>Passenger phone:</strong> {{ voucher.celularPassageiro }}</div>
    </ion-card-content>
  </ion-card>

  <div *ngIf="voucher" class="actions">
    <ion-button expand="block" color="primary" (click)="share()">
      <ion-icon name="share-social-outline" slot="start"></ion-icon>
      Share with customer
    </ion-button>
    <ion-button expand="block" fill="outline" color="medium" (click)="copy()">
      <ion-icon name="copy-outline" slot="start"></ion-icon>
      Copy details
    </ion-button>
  </div>
</ion-content>
